/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-06 18:29:38
 * @Description: 维保计划管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const wbjzService = {

  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfwb/jzxx`, { params: params }); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfwb/jzxx/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfwb/jzxx`, fd); },

  // 更新
  update: (fd) => { return axios.put(`${iffApi}/xfwb/jzxx`, fd); },

  // 获取维保项目详情
  getInfo: (id) => { return axios.get(`${iffApi}/xfwb/jzxx/${id}`); }

};
